export default {
    "data": {
        "h5": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20210817/1629180115594.png",
                "https://s21.lgstatic.com/growth/activity/20210419/1618798398193.png",
                "https://s20.lgstatic.com/growth/activity/20210826/1629949660031.png",
                "https://s21.lgstatic.com/growth/activity/20210419/1618798417286.png",

                "https://s20.lgstatic.com/growth/activity/20210826/1629949774378.png",
                "https://s21.lgstatic.com/growth/activity/20210419/1618825381893.png",

                "https://s21.lgstatic.com/growth/activity/20211126/1637915448827.jpg?x-oss-process=style/80",
                "https://s21.lgstatic.com/growth/activity/20210826/1629949673988.png"
            ],
            "btnImg": {
                "receive": "https://s21.lgstatic.com/growth/activity/20210419/1618822421732.png",
                "footer": "https://s20.lgstatic.com/growth/activity/20210826/1629965450341.png",
                "footerB": "https://s21.lgstatic.com/growth/activity/20210826/1629965532141.png",
                "getmore": "https://s21.lgstatic.com/growth/activity/20210422/1619078718673.png"
            },
            "tabImgList": [
                {
                    "title": "项目一",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210419/1618825819305.png"
                }, {
                    "title": "项目二",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210419/1618825829329.png"
                }, {
                    "title": "项目三",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210421/1618975689995.png"
                }, {
                    "title": "项目四",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210422/1619078653278.png"
                }
            ]
        },
        "pc": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20210817/1629180782695.png",
                "https://s21.lgstatic.com/growth/activity/20210422/1619061089029.png",
                "https://s20.lgstatic.com/growth/activity/20210826/1629949441718.png",
                "https://s20.lgstatic.com/growth/activity/20210826/1629949532051.png",
                "https://s21.lgstatic.com/growth/activity/20210422/1619074243435.png",

                "https://s21.lgstatic.com/growth/activity/20210817/1629181935441.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637915549429.jpg?x-oss-process=style/80"
            ],
            "tabImgList": [
                {
                    "title": "项目一",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210422/1619075428455.png"
                }, {
                    "title": "项目二",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210422/1619075436944.png"
                }, {
                    "title": "项目三",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210422/1619075449343.png"
                }, {
                    "title": "项目四",
                    "desc": "https://s21.lgstatic.com/growth/activity/20210422/1619075483112.png"
                }
            ],
            "btnImg": {
                "receive": "https://s21.lgstatic.com/growth/activity/20210422/1619077892533.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20210826/1629965559827.png",
                "footerB": "https://s20.lgstatic.com/growth/activity/20210826/1629965629508.png",
                "stageMore": "https://s21.lgstatic.com/growth/activity/20210514/1620965212539.png"
            }
        },
        "tabMain": {
            "h5titleImg": "https://s21.lgstatic.com/growth/activity/20210419/1618800070908.png",
            "pctitleImg": "https://s21.lgstatic.com/growth/activity/20210422/1619061424749.png",
            "stageList": [
                {
                    "stage": "第一阶段",
                    "title": "AI语法基础",
                    "phaseTargetList": [
                        "全面系统地讲授Python语法基础，面向对象，高阶函数，模块化运用。为后面的数据描述性分析打下基础，同时具备自动化处理数据的能力。",
                        "基于Numpy实现科学计算，通过Numpy生成ndarray、索引和切片，对数组进行面向组编程。",
                        "基于Pandas科学计算库实现数据预处理和数据分析，创建Series和DataFrame用于多种格式的读写以及数据转换。",
                        "基于绘图库(Matplotlib)实现数据可视化，通过Matplotlib绘图设置颜色、标记，对图例进行刻度、标签和图例设置。"
                    ],
                    "skillsList": [
                        "Python基础",
                        "NumPy科学计算库",
                        "Pandas数据分析库",
                        "Matplotlib数据绘图",
                    ],
                    "details": [
                        {
                            "t": "模块一：Python基础",
                            "desc": [
                                "Anaconda工具使用",
                                "AI案例介绍（sklearn）",
                                "基础语法（数据类型、运算符）",
                                "字符串、列表、元组",
                                "条件控制、循环语句",
                                "函数、类、模块",
                                "文件操作、异常处理"
                            ]
                        }, {
                            "t": "模块二：NumPy科学计算库",
                            "desc": [
                                "数组基础：索引、切片、变形、分裂",
                                "数组运算：通用函数",
                                "数组变形、拼接",
                                "数组计算：广播、聚合、比较和掩码、数组排序"
                            ]
                        }, {
                            "t": "模块三：Pandas数据分析库",
                            "desc": [
                                "数据结构（Series,Dataframe,Index）",
                                "数据加载与存储",
                                "数值运算方法：通用函数、聚合函数、遍历",
                                "层次化索引",
                                "数据处理：数据类型转换、缺失值处理、字符串转换",
                                "数据表的合并与连接",
                                "数据的累计与分组",
                                "query()、eval() 实现高性能运算"
                            ]
                        }, {
                            "t": "模块四：Matplotlib数据绘图",
                            "desc": [
                                "常用图形绘制",
                                "与Pandas 结合做可视化",
                                "Seaborn 介绍与图形绘制",
                                "数学和统计函数、线性代数"
                            ]
                        }, {
                            "t": "实战应用项目",
                            "desc": [
                                "拉勾招聘数据分析"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第二阶段",
                    "title": "机器学习原理与算法应用",
                    "phaseTargetList": [
                        "介绍KNN/K近邻算法、线性回归算法、逻辑回归算法、决策树、集成算法等常用监督学习算法，并通过案例对各种算法进行实操演练。",
                        "介绍常用无监督学习算法的原理及相关参数，并通过案例进行实操演练。",
                        "介绍数据预处理及特征工程，加快模型求解速度，提升模型精度。",
                        "介绍神经网络基础模型感知机与SVM，并通过多层感知机、SVM实现手写数字识别。"
                    ],
                    "skillsList": [
                        "有监督学习算法",
                        "无监督学习算法",
                        "特征工程",
                        "SVM与感知机"
                    ],
                    "details": [
                        {
                            "t": "模块一：有监督学习算法",
                            "desc": [
                                "线性回归（岭回归、lasso）",
                                "逻辑回归",
                                "决策树",
                                "集成算法（决策树、随机森林、GBDT、XGBoost、LightGBM）"
                            ]
                        }, {
                            "t": "模块二：无监督学习算法",
                            "desc": [
                                "聚类（K-Means）",
                                "降维（PCA）"
                            ]
                        }, {
                            "t": "模块三：特征工程",
                            "desc": [
                                "特征工程方法",
                                "模型调优方法",
                                "模型评估度量准则"
                            ]
                        }, {
                            "t": "模块四：SVM与感知机",
                            "desc": [
                                "感知机理论基础",
                                "多层感知机实现手写数字识别",
                                "SVM理论基础",
                                "线性SVM与非线性SVM",
                                "SVM核函数"
                            ]
                        }, {
                            "t": "实战应用项目",
                            "desc": [
                                "房价预测",
                                "电商用户购买力分析金融业",
                                "实现用户分类(用户画像)"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第三阶段",
                    "title": "人工智能应用：推荐系统",
                    "phaseTargetList": [
                        "介绍推荐系统的工作流程，了解推荐系统冷启动问题，掌握常用推荐系统评测指标、评测维度等。",
                        "介绍推荐系统的常用召回方法，以及两种测评方法：离线评测、在线测评。",
                        "介绍推荐系统传统模型、集成排序模型，以及最新工业常用模型。"
                    ],
                    "skillsList": [
                        "推荐系统理论基础",
                        "召回",
                        "排序"
                    ],
                    "details": [
                        {
                            "t": "模块一：推荐系统理论基础",
                            "desc": [
                                "推荐系统流程",
                                "常用推荐系统指标",
                                "推荐系统冷启动问题"
                            ]
                        }, {
                            "t": "模块二：召回",
                            "desc": [
                                "协同过滤基础概念",
                                "基于用户的协同过滤（User-Based CF）",
                                "基于物品的协同过滤（Item CF）",
                                "基于内容相似的召回（word2vec）"
                            ]
                        }, {
                            "t": "模块三：排序",
                            "desc": [
                                "传统排序模型（LR，FM，GBDT，DNN）",
                                "集成排序模型（wide&Deep,DeepFM）",
                                "最新工业常用模型（ESMM，MMoE）"
                            ]
                        }, {
                            "t": "实战应用项目",
                            "desc": [
                                "拉勾职位推荐系统"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第四阶段",
                    "title": "深度学习原理与算法应用",
                    "phaseTargetList": [
                        "介绍深度学习概述及神经网络结构，通过该模块学习，掌握深度学习框架TensorFlow 2.X框架，并学习tensor基础操作（索引与切片、维度变换、前向传播等）以及TensorFlow高级API完成建模、构建数据管道等。",
                        "介绍卷积神经网络（CNN）基本结构及理论基础，通过案例实现图片压缩与图片降噪处理。",
                        "介绍循环神经网络（RNN）基本结构及理论基础，通过案例实战完成对文本进行分类，实现语音标记。",
                        "介绍对抗神经网络（GAN）基本结构及理论基础，通过案例实现聊天机器人。"
                    ],
                    "skillsList": [
                        "深度学习基础",
                        "卷积神经网络（CNN）",
                        "循环神经网络（RNN）",
                        "对抗神经网络（GAN）"
                    ],
                    "details": [
                        {
                            "t": "模块一：深度学习基础",
                            "desc": [
                                "深度学习概述",
                                "DNN基础原理",
                                "BP算法原理（与RBF区别）",
                                "TensorFlow 基础",
                                "TensorFlow 高级",
                                "TensorFlow 实现机器学习"
                            ]
                        }, {
                            "t": "模块二：卷积神经网络（CNN）",
                            "desc": [
                                "卷积（局部特征提取）",
                                "池化（聚合、Pooling）",
                                "分类网络（全连接）",
                                "自编码器（AE）"
                            ]
                        }, {
                            "t": "模块三：循环神经网络（RNN）",
                            "desc": [
                                "时间递归神经网络",
                                "结构递归神经网络",
                                "模型优化方法",
                                "长时记忆/递归深度问题"
                            ]
                        }, {
                            "t": "模块四：对抗神经网络（GAN）",
                            "desc": [
                                "GAN基础原理",
                                "GAN系列API讲解"
                            ]
                        }, {
                            "t": "实战应用项目",
                            "desc": [
                                "图片分类、图片降噪处理",
                                "基于RNN+LSTM实现文本分类",
                                "基于GAN实现聊天机器人"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第五阶段",
                    "title": "人工智能应用：计算机视觉",
                    "phaseTargetList": [
                        "介绍计算机视觉理论基础其中包含（图像存储原理、形态学、图像特征描述等），掌握框架OpenCV、PyTorch。",
                        "介绍计算机神经网络理论基础，并与传统神经网络对比，掌握改进后的神经网络。",
                        "介绍图像目标检索，掌握常见CNN网络结构（AlexNet,VGG,GoogLeNet,ResNet）。",
                        "介绍图片分割技术，并掌握卷积神经网络优化后的网络结构（R-CNN,SPP-NET,Fast/FasterR-CNN）",
                        "介绍GAN在图像生成中的应用，掌握常见改进后的GAN（GAN,CGAN,DCGAN,WGAN）"
                    ],
                    "skillsList": [
                        "计算机视觉基础",
                        "神经网络与深度学习基础",
                        "目标检索",
                        "图像分割",
                        "图像生成"
                    ],
                    "details": [
                        {
                            "t": "模块一：计算机视觉基础",
                            "desc": [
                                "图像存储原理",
                                "图像预处理（存储原理、点运算、形态学、空间域）",
                                "图像特征描述（颜色特征、几何特征、基于关键点特征）",
                                "框架介绍及环境搭建（OpenCV、TensorFlow、PyTorch）"
                            ]
                        }, {
                            "t": "模块二：神经网络与深度学习基础",
                            "desc": [
                                "传统方法（图像分割、人脸检测、行人检测）",
                                "神经网络（神经元、前馈网络、梯度下降、误差反向传播）",
                                "与传统神经网络的区别",
                                "改进的神经网络",
                                "目标函数"
                            ]
                        }, {
                            "t": "模块三：目标检索",
                            "desc": [
                                "图像检索（相似检索、索引加速）",
                                "常见的CNN（AlexNet,VGG,GoogLeNet,ResNet）"
                            ]
                        }, {
                            "t": "模块四：图像分割",
                            "desc": [
                                "区域卷积神经网络优化（R-CNN,SPP-NET,Fast/FasterR-CNN）",
                                "全卷积神经网络 FCN"
                            ]
                        }, {
                            "t": "模块五：图像生成",
                            "desc": [
                                "循环神经网络优化（RNN,VanillaRNN,LSTM,GRU）",
                                "样本分布学习",
                                "语义分割",
                                "对抗网络优化（GAN,CGAN,DCGAN,WGAN）SRGAN"
                            ]
                        }, {
                            "t": "实战应用项目",
                            "desc": [
                                "银行卡识别",
                                "人脸识别",
                                "图像生成"
                            ]
                        }
                    ]
                }
            ]
        },
    }
}
